import { defineComponent as F, useSlots as G, computed as t, watchEffect as H, createBlock as p, openBlock as s, unref as g, withCtx as L, createElementVNode as k, normalizeClass as n, createElementBlock as h, createCommentVNode as d, renderSlot as C, mergeProps as U, resolveDynamicComponent as J, toRaw as K } from "vue";
import M from "../CheckboxBase/CheckboxBase.vue2.js";
import { RevIllustration as Q } from "@ds/components/Illustration";
import { isString as m } from "../../utils/isString.js";
import { isValidNumber as w } from "../../utils/isValidNumber.js";
import { tw as a } from "../../utils/tailwind.js";
import { CHANGE_EVENT as X } from "./Checkbox.constant.js";
const Y = ["for"], ie = /* @__PURE__ */ F({
  name: "RevCheckbox",
  __name: "Checkbox",
  props: {
    checked: { type: [Boolean, Array], default: void 0 },
    modelValue: { type: [Boolean, Array], default: !1 },
    disabled: { type: Boolean, default: !1 },
    displayDescriptionOnlyWhenChecked: { type: Boolean, default: !1 },
    id: {},
    image: { default: void 0 },
    imageProps: { default: void 0 },
    value: { default: "on" },
    variant: { default: "default" }
  },
  emits: ["change", "update:modelValue"],
  setup(i, { emit: N }) {
    const e = i, b = G(), f = N, A = t(() => b.label ? e.variant !== "imageOnly" : !1), V = t(() => b.description ? e.variant === "full" : !1), r = t(() => e.value && Array.isArray(e.checked) ? e.checked.includes(e.value) : e.value && Array.isArray(e.modelValue) ? e.modelValue.includes(e.value) : e.checked !== void 0 ? e.checked : e.modelValue !== void 0 ? e.modelValue : !1);
    function x(l) {
      const u = l;
      f(X, u);
      const j = ["checked", "modelValue"];
      for (const T of j) {
        const c = e[T];
        if (typeof c == "boolean") {
          f("update:modelValue", u.target.checked);
          return;
        }
        if (Array.isArray(c)) {
          const W = u.target.checked ? [...c, e.value] : c.filter((z) => z !== e.value), q = Array.from(new Set(W));
          f("update:modelValue", q);
          return;
        }
      }
    }
    const o = t(() => {
      const l = e.imageProps || {};
      return {
        ...l,
        height: w(l.height) ? l.height : 24,
        width: w(l.width) ? l.width : 24,
        src: m(e.image) ? e.image : void 0,
        alt: m(l.alt) ? l.alt : void 0
      };
    }), B = t(() => e.variant !== "default" && m(o.value.alt));
    H(() => {
      if (e.variant === "imageOnly" && !o.value.alt)
        throw new Error(
          "Checkbox: image must have an alt text when using the ImageOnly variant."
        );
    });
    function y(l) {
      return m(l);
    }
    const D = t(() => typeof e.image == "object"), v = a`ease-in motion-safe:transition-colors motion-safe:duration-200`, E = t(() => [
      a`text-static-default-low body-2 ml-32 pt-8`,
      e.displayDescriptionOnlyWhenChecked && !r.value && a`hidden`,
      e.disabled && a`text-static-default-low-disabled`,
      v
    ]), O = t(() => [
      v,
      a`body-1 block`,
      e.variant !== "default" && a`rounded-sm box-border border p-16 peer-focus-visible:outline-default-hi`,
      e.variant === "full" && a`min-h-56`,
      !e.disabled && r.value && a`border-action-default-low-pressed`,
      !e.disabled && !r.value && a`border-action-default-low`,
      !e.disabled && e.variant !== "default" && a`bg-static-default-low hover:bg-static-default-low-hover`,
      !e.disabled && a`text-action-default-hi cursor-pointer`,
      e.disabled && e.variant !== "default" && a`bg-static-default-low-disabled border-action-default-low-disabled`,
      e.disabled && a`text-action-default-hi-disabled cursor-not-allowed`
    ]), P = a`ml-32 flex`, S = a`flex-1 ${v}`, I = t(() => [
      a`flex max-h-24 items-center`,
      e.variant === "full" && a`ml-16`,
      e.disabled && a`opacity-50`
    ]), R = t(() => ({
      full: a`left-16 top-20`,
      imageOnly: a`left-16 top-16 peer-focus-visible:outline-default-hi`,
      default: a`top-2 peer-focus-visible:outline-default-hi`
    })[e.variant]), $ = t(() => e.variant === "full" && !r.value);
    return (l, u) => (s(), p(g(M), {
      id: i.id,
      disabled: i.disabled,
      "is-transparent": $.value,
      label: "",
      "model-value": r.value,
      "tick-class-names": R.value,
      value: i.value,
      onChange: x
    }, {
      default: L(() => [
        k("label", {
          class: n(O.value),
          for: i.id
        }, [
          k("div", {
            class: n(P)
          }, [
            A.value ? (s(), h("div", {
              key: 0,
              class: n(S)
            }, [
              C(l.$slots, "label")
            ])) : d("", !0),
            B.value ? (s(), h("div", {
              key: 1,
              class: n(I.value)
            }, [
              y(o.value.src) && y(o.value.alt) ? (s(), p(g(Q), U({ key: 0 }, o.value, {
                alt: o.value.alt,
                src: o.value.src
              }), null, 16, ["alt", "src"])) : d("", !0),
              D.value ? (s(), p(J(K(i.image)), {
                key: 1,
                "aria-label": o.value.alt,
                role: "img"
              }, null, 8, ["aria-label"])) : d("", !0)
            ], 2)) : d("", !0)
          ]),
          V.value ? (s(), h("div", {
            key: 0,
            class: n(E.value)
          }, [
            C(l.$slots, "description")
          ], 2)) : d("", !0)
        ], 10, Y)
      ]),
      _: 3
    }, 8, ["id", "disabled", "is-transparent", "model-value", "tick-class-names", "value"]));
  }
});
export {
  ie as default
};
